import { render, staticRenderFns } from "./RegistrySelect.vue?vue&type=template&id=3b535fc0&scoped=true&"
import script from "./RegistrySelect.vue?vue&type=script&lang=js&"
export * from "./RegistrySelect.vue?vue&type=script&lang=js&"
import style0 from "./RegistrySelect.vue?vue&type=style&index=0&id=3b535fc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b535fc0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VChip } from 'vuetify/lib/components/VChip';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VAutocomplete,VChip,VListItem,VListItemAction,VListItemContent,VListItemTitle,VSimpleCheckbox})
